import { Button, Col, DatePicker, Form, Select } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import {
  EXISTING_PO_MAP_LIST,
  GET_DIGITALIZATION_STYLES,
  GET_SEWING_LINE_ENDPOINT,
  PO_MAP_NEW_ENDPOINT,
  SEWING_LINES,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";
import SubStyleFilterCol from "./SubStyleFilterCol";

const MismatchReportFilter = ({ initialTableData, filterClearTrigger = 0 }) => {
  // States
  const [stylesList, setStylesList] = useState([]);
  const [finishingLineList, setFinishingLineList] = useState([]);
  // Antd
  const { Option } = Select;

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };
    const response = await getData(GET_DIGITALIZATION_STYLES, false, bodyData);

    if (response && response?.data?.code === 200) {
      const styles =
        response?.data?.data?.data?.map((style) => ({
          id: style.id,
          name: style.style_no,
        })) || [];
      setStylesList(styles);
    }
  };

  const fetchFinishingLines = useCallback(async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 10,
      ...filterValues,
    };

    const query = GET_SEWING_LINE_ENDPOINT;

    try {
      const response = await getData(query, false, bodyData);

      if (response?.status === 200) {
        const dropdownData = response?.data?.data?.data?.map((item) => ({
          name: item.name,
          id: item.id,
        }));
        setFinishingLineList(dropdownData);
      }
    } catch (error) {}
  }, []);

  // Effects

  // Effects
  useEffect(() => {
    getStyleList();
    fetchFinishingLines();
  }, [fetchFinishingLines]);

  return (
    <>
      {/* Entry Date picker at the very beginning */}
      {/* Fix round 1 (ux-sweep batch 2, finding 1): must show the same
          "today" default that mismatch-report/index.js seeds its own
          filterValues state with (getDefaultFilterValues()). Kept as a
          literal expression here (rather than importing from the page) to
          avoid a common -> feature import; if that page's default ever
          changes, this must change with it. */}
      <Col span={4}>
        <Form.Item
          label="Entry Date"
          name="entry_date"
          initialValue={moment()}
          rules={[{ required: true, message: "Please select entry date" }]}
        >
          <CustomDatePicker placeholder="Select a date" size="small" />
        </Form.Item>
      </Col>

      <Col span={4}>
        <Form.Item label="Style" name="style_id">
          <Select
            showSearch
            placeholder="Select Style"
            filterOption={false}
            size="small"
            onSearch={(value) => {
              getStyleList({ style_no: value });
            }}
          >
            {isArrayAndHasValue(stylesList) &&
              stylesList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <SubStyleFilterCol filterClearTrigger={filterClearTrigger} />

      <Col span={4}>
        <Form.Item label="Line" name="line_id">
          <Select
            showSearch
            placeholder="Select a Line"
            onSearch={(value) => {
              fetchFinishingLines({ name: value });
            }}
            optionFilterProp="children"
            size="small"
            allowClear
            onClear={() => fetchFinishingLines()}
          >
            {isArrayAndHasValue(finishingLineList) &&
              finishingLineList.map((line) => (
                <Option value={line.id} key={line.id}>
                  {line.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default MismatchReportFilter;
